import { Controller } from "@hotwired/stimulus"
import {FetchRequest} from '@rails/request.js'

export default class extends Controller {
    static targets = ["password", "passwordConfirmation","passwordButton","passwordPreview","usePassword"]
    static values = {
        generatedPassword: String
    };

    async generate() {
        const request = new FetchRequest("get", 'users/generate_password.json', {
            responseKind: "json",
        })
        const response = await request.perform()

        if (response.ok) {
            const data = await response.json
        } else {
            
            console.log(response)
        }
        //const password = this.generatedPasswordValue

        const data = await response.json

        const password = data.password
        console.log(response)
        this.generatedPasswordValue = password

        this.passwordPreviewTarget.outerHTML =`<div data-password-generator-target="passwordPreview" class="text-2xl text-gray-600 font-mono  bg-yellow-100 p-4 mt-2">` + password + `</div>`
        this.usePasswordTarget.outerHTML =`<div data-password-generator-target="usePassword">
<button type="button" 
data-action="password-generator#use", 
class="mt-4 border border-gray-300 rounded-md px-2 py-1 hover:bg-gray-100">Use Password
</button> Keep Safe, we do not store the password, so there is no way to retrieve it.</div>`
    }

    use() {
        const password = this.generatedPasswordValue
        console.log(password)

        this.usePasswordTarget.innerHTML = ''
        this.passwordConfirmationTarget.value = password
        this.passwordTarget.value = password
        this.passwordPreviewTarget.outerHTML =`<span data-password-generator-target="passwordPreview"></span>`
        this.passwordButtonTarget.outerHTML = `
<button type="button" 
data-password-generator-target="passwordButton" 
data-action="password-generator#generate", 
class="mt-4 border border-gray-300 rounded-md px-2 py-1 hover:bg-gray-100">
Generate password
    </button>`
    }


}